export const DateHelper = {
    timeSinceDate: (dateSearched: Date): string => {

            const current = new Date();
    
            const diffInMS = current.getTime() - dateSearched.getTime();
            const diffInS = diffInMS / 1000;
    
            if (diffInS < 60) {
                return 'seconds ago';
            }
    
            const diffInM = diffInS / 60;
            if (diffInM < 60) {
                return `${Math.round(diffInM)} minute${Math.round(diffInM) > 1 ? 's' : ''} ago`;
            }
    
            const diffInH = diffInM / 60;
            if (diffInH < 24) {
                return `${Math.round(diffInH)} hour${Math.round(diffInH) > 1 ? 's' : ''} ago`;
            }
    
            const diffInD = diffInH / 24;
            if (diffInD < 10) {
                return `${Math.round(diffInD)} day${Math.round(diffInD) > 1 ? 's' : ''} ago`;
            }
    
            return '';
        },
    
    timeFromSeconds: (seconds:number): string => {

        if (seconds < 60) {
            return `${seconds} seconds`;
        }

        const diffInM = seconds / 60;
        if (diffInM < 60) {
            return `${Math.round(diffInM)} Min${Math.round(diffInM) > 1 ? 's' : ''}`;
        }

        const diffInH = diffInM / 60;
        if (diffInH < 24) {
            return `${Math.round(diffInH)} Hr${Math.round(diffInH) > 1 ? 's' : ''} ${Math.round(diffInM % 60)} Min${Math.round(diffInM % 60) > 1 ? 's' : ''}`;
        }

        const diffInD = diffInH / 24;
        if (diffInD < 10) {
            return `${Math.round(diffInD)} day${Math.round(diffInD) > 1 ? 's' : ''} ${Math.round(diffInM % 60)} Min${Math.round(diffInM % 60) > 1 ? 's' : ''}`;
        }

        return '';
    },

    buildDateFormat: (dt: Date): string => {
        if (!dt) {
            return '';
        }

        return dt.toLocaleDateString('en-us', { month: 'short', day: "numeric", year: "numeric"});
    },

    renewalDate: (isTrial: boolean): string => {
        let today = isTrial ? new Date(Date.now() + 12096e5) : new Date();
        let nextMonth = (today.getMonth() + (isTrial ? 0 : 1)) % 12 + 1;
        let year = today.getFullYear();
        let day = today.getDate();
        switch (nextMonth) {
            case 1:
                return `January ${day}, ${year}`;
            case 2:
                return `February ${day}, ${year}`;
            case 3:
                return `March ${day}, ${year}`;
            case 4:
                return `April ${day}, ${year}`;
            case 5:
                return `May ${day}, ${year}`;
            case 6:
                return `June ${day}, ${year}`;
            case 7:
                return `July ${day}, ${year}`;
            case 8:
                return `August ${day}, ${year}`;
            case 9:
                return `September ${day}, ${year}`;
            case 10:
                return `October ${day}, ${year}`;
            case 11:
                return `November ${day}, ${year}`;
            case 12:
                return `December ${day}, ${year}`;
            default:
                return "today next month";
        }
    },
    addDays: (date: Date, days: number) => {
		const result = new Date(date);
		result.setDate(result.getDate() + days);
		return result;
	},
    getDatesBetween: (startDate: Date, endDate: Date): Date[] => {
        const dates:Date[] = [];
        let currentDate = startDate;
        while (currentDate <= endDate) {
            dates.push(new Date(currentDate));
            currentDate = DateHelper.addDays(currentDate, 1);
        }
        return dates;
    },
    sameCalendarDate: (date1: Date, date2: Date): boolean => {
        return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
    }
}

export default DateHelper;